import { Component, Input } from '@angular/core';
import { GenericModalSources } from '@legacy/common-ui-shared-interfaces';
import { Store } from '@ngrx/store';

import { solarPanelsShowPropositionMoreInfoModalAction } from '../../store';
import type { SolarPanelsPropositionBoxFields } from '../../models/solar-panels-result-overview-rendering.interface';

@Component({
  selector: 'wl-solar-panels-proposition-box',
  templateUrl: './solar-panels-proposition-box.component.html',
  styleUrls: [
    'solar-panels-proposition-box.component.essent.scss',
    'solar-panels-proposition-box.component.ed.scss',
  ],
})
export class SolarPanelsPropositionBoxComponent {
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input({ required: true }) rendering!: {
    fields: SolarPanelsPropositionBoxFields;
  };

  constructor(private readonly store: Store) {}

  openMoreInfoModal() {
    if (this.rendering.fields.PropositionMoreInfoModal) {
      const { Body, Title, ComponentName } =
        this.rendering.fields.PropositionMoreInfoModal.fields;

      this.store.dispatch(
        solarPanelsShowPropositionMoreInfoModalAction({
          props: {
            body: Body?.value ?? '',
            source: GenericModalSources.GENERIC_MODAL,
            title: Title?.value ?? '',
            tracking: { componentName: ComponentName?.value ?? '' },
          },
        })
      );
    }
  }
}
